import React, {useContext, useState} from "react";
import {toast} from "react-hot-toast";
import Select from "react-select";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxStation from "../../../util/remote/ajaxStation";
import StationContext from "../../../Context/StationContext";

function AddSetting(props) {
  const [station, setStation] = useState("");
  const [authMethod, setAuthMethod] = useState("");
  const [school, setSchool] = useState("");
  const [category, setCategory] = useState("");
  const {schoolList} = useContext(SchoolContext);
  const [loading2, setLoading2] = useState(false);
  const {allStationList} = useContext(StationContext);

  const handleAdd = async (e) => {
    e.preventDefault();
      if (authMethod.length > 0) {
        setLoading2(true)
        const server_response = await ajaxStation.createSetting(authMethod, station, school);
        setLoading2(false)
        if (server_response.status === "OK") {
          toast.success(server_response.message);
          props.g();
          props.h();
          props.i();
          resetForm();
        } else {
          toast.error(server_response.message);
        }
      } else {
        toast.error("Please select an authentication method!");
      }
    
  };

  const resetForm = () => {
    setAuthMethod("");
    setCategory("");
    setStation("");
    setSchool("");
  };

  return (
    <div className="card height-auto">
      <div className="card-body">
        <div className="heading-layout1">
          <div className="item-title">
            <h5 style={{marginBottom:0}}>Add Booth Authentication Setting</h5>
          </div>
        </div>
        <form
          onSubmit={(e) => handleAdd(e)}
          method="post"
          class="new-added-form">
          <div className="row">
            <div className="col-lg-12 col-12 form-group">
              <label htmlFor="">Setting Category <span style={{color:"red"}}>*</span> </label>
              <select className="col-12 form-control" value={category} style={{border: "1px solid grey"}} onChange={(e) => setCategory(e.target.value)}>
                <option value={true}>Select...</option>
                <option value="Global">Global Setting</option>
                <option value="School">School Setting</option>
                <option value="Station">Station Setting</option>

              </select>
            </div>
            <div className="col-lg-12 col-12 form-group">
              <label htmlFor="">Authentication Method <span style={{color:"red"}}>*</span> </label>
               <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={authMethod}
                    onChange={(e) => setAuthMethod(e.target.value)}>
                    <option value="" selected disabled>Select authentication method..</option>
                    <option value="Card">Card / Wristband</option>
                    <option value="Face">Face</option>
                    <option value="Thumb">Fingerprint</option>

                </select>
            </div>
            {category === "School"? <div className="col-lg-12 col-12 form-group">
                <label htmlFor="">School <span style={{color:"red"}}>*</span></label>
                <Select
                  onChange={(e) => setSchool(e.school_id)}
                  getOptionLabel={(option) => option.school_name}
                  getOptionValue={(option) => option.school_id}
                  isSearchable
                  options={Array.isArray(schoolList) ? schoolList : []}
                  value={
                      Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_id === school)
                  }
                />
            </div> :
            
            category === "Station" ?
            <div className="col-lg-12 col-12 form-group">
                <label htmlFor="">Station / Booth <span style={{color:"red"}}>*</span></label>
                <Select
                  onChange={(e) => setStation(e.station_id)}
                  getOptionValue={(option) => option.station_id}
                  getOptionLabel={(option) => `${option.station_name} (${option.station_code})`}
                  isSearchable
                  required
                  options={Array.isArray(allStationList) ? allStationList : []}
                  value={
                      Array.isArray(allStationList) &&
                      allStationList.find((value) => value.station_id === station)
                  }
                />
            </div>:""}
            
          </div>
          <div className="mt-5">
          {loading2 && (<button type="submit" className="col-xl-12 col-lg-12 col-12 btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue" disabled><i class="fa fa-spinner fa-spin mr-2"></i>Disabling...</button>)}
            {!loading2 && <button
              type="submit"
              className="col-xl-12 col-lg-12 col-12 btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue">
              Disable Authentication
            </button>}
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddSetting
